module.exports = __webpack_public_path__ + "static/media/close.f8adfd4a.svg";